import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { WeeklyBalance } from './WeeklyBalance';
export const Header = () => {
  const {
    user,
    profile,
    signOut
  } = useAuth();
  return <div className="flex flex-col sm:flex-row justify-between items-center gap-2 w-full px-4 pb-4">
      <div className="flex flex-col items-center sm:items-start">
        <h2 className="text-xl font-semibold text-slate-300">{profile?.email || user?.email || 'Guest'}</h2>
        <WeeklyBalance className="mt-1" />
      </div>
      
      <Button variant="outline" size="sm" onClick={() => signOut()} className="flex items-center gap-2 bg-[#1e293b] text-white border-[#374151] hover:bg-[#2d3748] hover:text-white">
        <LogOut className="h-4 w-4" />
        Logout
      </Button>
    </div>;
};